<template>
  <section>
    <aAlert
      v-if="type === 'edit'"
      class="mb-10 f12"
      type="info"
      banner
      message="Selecione os trechos que deseja alterar."
    />

    <div class="flight-row">
      <aCheckboxGroup v-model="selectedRows" @change="onChangeProductRow">
        <div
          v-for="(section, index) in product.sections"
          class="infos mb-10"
          :key="index"
        >
          <aRow :gutter="20">
            <aCol v-if="type === 'edit'" :span="1">
              <aCheckbox :value="section.id" />
            </aCol>

            <aCol :span="type === 'edit' ? 23 : 24">
              <aRow :gutter="20">
                <aCol :span="4">
                  <span class="label">Origem:</span>
                  {{ section.origin }}
                </aCol>

                <aCol :span="4">
                  <span class="label">Destino:</span>
                  {{ section.destination }}
                </aCol>

                <aCol :span="5">
                  <span class="label">Voo:</span>
                  {{ section.type }} (Nº {{ section.number }})
                </aCol>

                <aCol :span="5">
                  <span class="label"> Classe:</span>
                  {{ section.class }}
                </aCol>

                <aCol :span="5">
                  <span class="label"> Cia:</span>
                  {{ section.airline }}
                </aCol>
                <aCol class="mt-10" :span="6">
                  <span class="label"> Embarque:</span>
                  {{ section.departure }}
                </aCol>
                <aCol class="mt-10" :span="6">
                  <span class="label"> Desembarque:</span>
                  {{ section.arrival }}
                </aCol>
                <aCol class="mt-10" :span="6">
                  <span class="label"> Duração:</span>
                  {{ section.duration }}
                </aCol>

                <aCol class="mt-10" :span="6">
                  <span class="label"> Paradas:</span>
                  {{ section.stops }}
                </aCol>
              </aRow>
            </aCol>
          </aRow>

          <div
            class="form"
            v-if="selectedRows.includes(section.id) && type === 'edit'"
          >
            <ContractCancelFlightForm
              class="mt-30"
              :product="product"
              :tempContract="tempContract"
              :rowId="section.id"
              @onIsSavingData="onIsSavingData"
              @onChangeCancelProductData="onChangeCancelProductData"
            />
          </div>
        </div>
      </aCheckboxGroup>

      <aForm @submit.prevent="onSubmitForm" :form="form">
        <aRow class="" align="middle" :gutter="20">
          <aCol class="mb-5" :span="24"><h4>VIAJANTES</h4> </aCol>
          <aCol class="mb-20" v-if="cancelSpecificTravelers" :span="24">
            <aAlert
              class="f12"
              type="warning"
              banner
              message="Os viajantes selecionados abaixo serão removidos dos calculos e multas."
            />
          </aCol>
          <aCol class="travellers" :span="24">
            <aCheckboxGroup
              v-model="selectedTravelersRows"
              @change="onChangeTravelerRow"
              style="width: 100%"
            >
              <div
                class="traveller upper f12"
                v-for="(traveller, index) in product.travellers"
                :key="index"
              >
                <aRow align="middle">
                  <aCol v-if="cancelSpecificTravelers" :span="1">
                    <aCheckbox :value="traveller.id" />
                  </aCol>

                  <aCol
                    :class="
                      selectedTravelersRows.includes(traveller.id) ? 'cut' : ''
                    "
                    :span="14"
                  >
                    {{ traveller.name }}
                  </aCol>

                  <aCol :span="5">
                    <aFormItem style="margin-top: -10px" v-if="type === 'edit'">
                      <aInput
                        class="travel-input f12"
                        :class="
                          selectedTravelersRows.includes(traveller.id)
                            ? 'none'
                            : ''
                        "
                        size="small"
                        placeholder="Localizador"
                        v-decorator="[
                          `flight_${product.id}_traveller_${traveller.id}_locator_new`,
                          {
                            rules: [
                              {
                                required: !selectedTravelersRows.includes(
                                  traveller.id
                                )
                                  ? true
                                  : false,
                                message: 'Escreva o localizador.',
                              },
                            ],
                          },
                        ]"
                      >
                      </aInput>
                    </aFormItem>
                  </aCol>

                  <aCol
                    :class="
                      selectedTravelersRows.includes(traveller.id) ? 'cut' : ''
                    "
                    class="a-right"
                    :span="4"
                  >
                    {{ formatMultiDates(traveller.birthday) }}
                  </aCol>
                </aRow>
              </div>
            </aCheckboxGroup>
          </aCol>

          <aCol v-if="type === 'edit'" class="a-right" :span="24">
            <aDivider />

            <aButton
              class="page-button mb-30"
              type="primary"
              html-type="submit"
              icon="save"
              :loading="loadingSubmit"
              :disabled="loadingSubmit"
            >
              {{ loadingSubmit ? "Salvando, aguarde..." : " Confirmar" }}
            </aButton>
          </aCol>
        </aRow>
      </aForm>

      <aCol v-if="cancelSpecificTravelers" class="a-right" :span="24">
        <aDivider />

        <aButton
          class="page-button mb-30"
          type="primary"
          html-type="submit"
          icon="save"
          :loading="loadingSubmit"
          :disabled="loadingSubmit"
          @click="onClickSaveTravellersToCancel"
        >
          {{ loadingSubmit ? "Salvando, aguarde..." : " Confirmar" }}
        </aButton>
      </aCol>
    </div>
  </section>
</template>

<script>
import formatThings from "@/mixins/general/formatThings.js";
import ContractCancelFlightForm from "./ContractCancelFlightForm.vue";

export default {
  name: "ContractModalFlightRow",
  props: {
    product: Object,
    tempContract: Object,
    type: String,
    cancelSpecificTravelers: Boolean,
    selectedRows: Array,
  },
  components: { ContractCancelFlightForm },
  mixins: [formatThings],
  data() {
    return {
      form: this.$form.createForm(this, {
        onValuesChange: this.updateTempContract,
      }),
      selectedTravelersRows: [],
      loadingSubmit: false,
    };
  },
  mounted() {
    const getParseStoredValue = (key) => {
      if (!this.tempContract || !this.product) return [];
      const value = this.tempContract[`flight_${this.product.id}_${key}`];
      return value ? JSON.parse(value) : [];
    };

    this.selectedRows = getParseStoredValue("cancel_selected_rows");
    this.selectedTravelersRows = getParseStoredValue(
      "cancel_selected_travelers_rows"
    );

    setTimeout(() => {
      this.selectedRows.forEach((traveler) => {
        this.form.setFieldsValue({
          [`flight_${this.product.id}_traveller_${traveler}_locator_new`]:
            this.tempContract[
              `flight_${this.product.id}_traveller_${traveler}_locator_new`
            ],
        });
      });
    }, 50);
  },
  methods: {
    updateTempContract(props, fields) {
      let field = Object.keys(fields)[0],
        value = Object.values(fields)[0];

      this.tempContract[field] = value;

      if (Array.isArray(value)) {
        this.tempContract[field] = JSON.stringify(value);
      }

      this.tempContract = { ...this.tempContract };

      this.$emit("onChangeCancelProductData", this.tempContract);
    },
    onChangeProductRow(selectedRows) {
      this.tempContract[`flight_${this.product.id}_cancel_selected_rows`] =
        JSON.stringify(selectedRows);
      this.onChangeCancelProductData(this.tempContract);
    },
    onChangeTravelerRow(selectedRows) {
      this.tempContract[
        `flight_${this.product.id}_cancel_selected_travelers_rows`
      ] = JSON.stringify(selectedRows);

      const filteredTravellers = this.product.travellers
        .filter((traveller) => !selectedRows.includes(traveller.id))
        .map((traveller) => traveller.id);

      console.log("filteredTravellers", selectedRows, filteredTravellers);

      this.tempContract[`flight_${this.product.id}_cancel_selected_rows`] =
        JSON.stringify(filteredTravellers);

      this.onChangeCancelProductData(this.tempContract);
    },
    onChangeCancelProductData(tempContract) {
      this.$emit("onChangeCancelProductData", tempContract);
    },
    onIsSavingData(loading) {
      this.$emit("onIsSavingData", loading);
    },
    onClickSaveTravellersToCancel() {
      this.loadingSubmit = true;

      this.$http
        .post("/contract/update-multi-meta", {
          id: this.tempContract.id,
          [`flight_${this.product.id}_cancel_selected_travelers_rows`]:
            JSON.stringify(this.selectedTravelersRows),
          [`flight_${this.product.id}_cancel_selected_rows`]:
            this.tempContract[`flight_${this.product.id}_cancel_selected_rows`],
          modified_by: {
            name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
            id: this.$store.state.userData.id,
          },
        })
        .then(({ data }) => {
          this.$message.success(data.message);
          this.$emit("onClickSaveTravellersToCancel", this.product);

          this.$http.post("/log/create", {
            user_id: this.$store.state.userData.id,
            module_id: this.tempContract.id,
            module: "contract",
            action: "cancel-travellers",
            description: `<b>[MODO CANCELAMENTO]</b> ${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name} alterou os viajantes para cancelamento.`,
          });
        })
        .finally(() => {
          this.loadingSubmit = false;
        });
    },
    onSubmitForm(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loadingSubmit = true;
          this.$emit("onIsSavingData", this.loadingSubmit);
          this.$http
            .post("/contract/update-multi-meta", {
              id: this.tempContract.id,
              ...values,
              modified_by: {
                name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
                id: this.$store.state.userData.id,
              },
            })
            .then(({ data }) => {
              this.$message.success(data.message);

              this.$http.post("/log/create", {
                user_id: this.$store.state.userData.id,
                module_id: this.tempContract.id,
                module: "contract",
                action: "cancel-model-update-travelers-locator",
                description: `<b>[MODO CANCELAMENTO]</b> ${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name} atualizou o localizador dos viajantes.`,
              });
            })
            .finally(() => {
              this.loadingSubmit = false;
              this.$emit("onIsSavingData", this.loadingSubmit);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-button {
  background: #00acec;
  border-color: #00acec;
}

.page-button:hover {
  background: #00a4e0;
  border-color: #00a4e0;
}
</style>

<style lang="sass" scoped>
.flight-row
  background: #FFF
  padding: 10px
  border: 1px solid #ddd !important
  margin: 0 0 10px
  border-radius: 6px
  font-size: 12px
  font-weight: 500
  .cut
    text-decoration: line-through
    color: #ccc
  .form
    background: #f6f6f6
    padding: 10px 20px 0
    margin: 20px -10px -11px -10px
    border-top: 1px solid #ddd
    border-bottom: 1px solid #ddd
  .label
    display: block
    font-size: 11px
    font-weight: 500
    color: #bbb
  .infos
    padding-bottom: 10px
    border-bottom: 1px dashed #ddd
    font-size: 12px
    color: #333
  .travellers
    .traveller
      padding: 0 0 8px 0
      margin: 0 0 8px
      border-bottom: 1px solid #eee
    .traveller:last-child
      border: 0
      padding-bottom: 0
    .font
      font-weight: 600
      border-radius: 4px
      font-size: 12px
      background: #eee
      padding: 1px 5px 2px
      margin: 4px 4px 0px 0
      text-transform: uppercase
      word-break: break-all
      float: left
</style>
